import { createSlice, PayloadAction, createSelector } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { setAllStates, startLoading, stopLoading } from "./Loading_Slice";
import { fetchWithTimeout } from 'utils/fetchWithTimeout';
import { buildColorQueryString } from "../utils/solr"
import { format, startOfMonth, parseISO } from 'date-fns';
import CONSTANTS from "../constants";
import { toastListProp, toastType, createToastProperties } from '../components/toast/Toast';
import { addToQueue } from "../services/Toasts_Slice";
import { getMonday } from '../components/utils/dateHelper';
import { batch } from 'react-redux';
//
const urldecode = require('urldecode');
var urlencode = require('urlencode');



interface Dictionary<T> {
    [Key: string]: T;
}

export enum viewType{
    List = 0,
    Calendar = 1
}

export enum calRangeType{
    month = 0,
    week = 1,
    day = 2,
    year = 3,
}

export enum sortType{
    descending = 0,
    ascending = 1,
}

export enum sortFieldType{
    'date' = 'file_modified_dt',
    'filename' = 'path_basename_s',
}

export enum reverseSortFieldType{
    'file_modified_dt' = 'date',
    'path_basename_s' = 'filename',
}

export type cursorsType = {
    cursorStart: number;
    cursorRows: number;
}

export type calValueType = {
    calRange: string | undefined;
}

export type uiDimensionsType = {
    width: number;
    height: number;
}

type viewchState = {
    total: number;
    //
    viewType: viewType;
    // for callendar:
    calRangeUsed : calRangeType | undefined;
    calRangeValue: string;
    // Store the last active date for each view type
    lastMonthDate: string;
    lastWeekDate: string;
    lastYearDate: string;
    // for list:
    cursorStart: number;
    cursorRows: number;
    listSortedFeld: sortFieldType;
    listSortedOrder : sortType;
    // for debug
    showDebugInfo: boolean;
    mobile: boolean;
    // for UI
    missionColorMap: Dictionary<string>;
    gradientColorMap: Dictionary<Dictionary<string>>;
    gradientValues: any;
    gradientLoading: boolean;
    heatmap: Dictionary<Dictionary<string>>;
    pageRangeUsed: number;
    // for mobile layout
    uiDimensions: uiDimensionsType;
    // from URL query params
    // facet partams
    urlFacetsConstraints: Array<string>;
    // boolean flag: url param used once only
    urlConstraintsUsed: boolean;
    // modal state for URL sharing
    modalOpen: boolean;
    modalDate: string;
    modalMission: string;
    // Date interval filter
    dateIntervalFrom: string | null;
    dateIntervalTo: string | null;
    // Pagination coordination flag
    paginationInProgress: boolean;
    // Flag to indicate FacetNavigation is auto-navigating the date
    // When true, date changes should NOT create new history entries
    isAutoNavigating: boolean;
}

var dateCurrentMonth = format(startOfMonth(new Date()), 'yyyy-MM');

let initialState: viewchState = {
    total: 0,
    viewType: viewType.Calendar,
    calRangeUsed: calRangeType.month,
    calRangeValue: dateCurrentMonth,
    lastMonthDate: dateCurrentMonth,
    lastWeekDate: format(getMonday(new Date()), 'yyyy-MM-dd'),
    lastYearDate: format(new Date(), 'yyyy'),
    cursorStart: 0,
    cursorRows: CONSTANTS.UI.ITEM_PER_PAGE_CHOICES[0],
    listSortedFeld: sortFieldType.date,
    listSortedOrder: sortType.descending,
    showDebugInfo: false,
    mobile: false,
    missionColorMap: {},
    gradientColorMap: {},
    gradientValues: {},
    gradientLoading: false,
    heatmap: {},
    pageRangeUsed: CONSTANTS.UI.ITEM_PER_PAGE_CHOICES[0],
    uiDimensions: {width: -1, height: -1},
    urlFacetsConstraints: [],
    urlConstraintsUsed: false,
    modalOpen: false,
    modalDate: '',
    modalMission: '',
    dateIntervalFrom: null,
    dateIntervalTo: null,
    paginationInProgress: false,
    isAutoNavigating: false
};


const viewSlice = createSlice({
    name: 'View',
    initialState: initialState,
    reducers: {
        setHeatMap(state, action: PayloadAction<Dictionary<Dictionary<string>>>) {
            state.heatmap=action.payload;
        },
        setGradientValues(state, action: PayloadAction<Dictionary<any>>) {
            state.gradientValues=action.payload;
        },
        setGradientLoading(state, action: PayloadAction<boolean>) {
            state.gradientLoading=action.payload;
        },
        setGradientColorMap(state, action: PayloadAction<Dictionary<Dictionary<string>>>) {
            state.gradientColorMap=action.payload;
        },
        setMissionColorMap(state, action: PayloadAction<Dictionary<string>>) {
            state.missionColorMap=action.payload;
        },
        setMobile(state, action: PayloadAction<boolean>) {
            state.mobile=action.payload;
        },
        setShowDebugInfo(state, action: PayloadAction<boolean>) {
            state.showDebugInfo=action.payload;
        },
        setTotal(state, action: PayloadAction<number>) {
            state.total=action.payload;
        },
        setType(state, action: PayloadAction<viewType>) {
            state.viewType=action.payload;
        },
        setCursors(state, action: PayloadAction<cursorsType>) {


            state.cursorStart=action.payload.cursorStart;
            state.cursorRows=action.payload.cursorRows;
        },
        setSortField(state, action: PayloadAction<sortFieldType>) {
            state.listSortedFeld=action.payload;
        },
        setSortOrder(state, action: PayloadAction<sortType>) {
            state.listSortedOrder=action.payload;
        },
        setCalRangeUsed(state, action: PayloadAction<calRangeType>) {
            // Store the current date value before changing the view
            if (state.calRangeUsed !== undefined) {
                switch (state.calRangeUsed) {
                    case calRangeType.month:
                        state.lastMonthDate = state.calRangeValue;
                        break;
                    case calRangeType.week:
                        state.lastWeekDate = state.calRangeValue;
                        break;
                    case calRangeType.year:
                        state.lastYearDate = state.calRangeValue;
                        break;
                }
            }

            // Set the new view type
            state.calRangeUsed = action.payload;

            // Restore the last active date for the new view type
            switch (action.payload) {
                case calRangeType.month:
                    state.calRangeValue = state.lastMonthDate;
                    break;
                case calRangeType.week:
                    state.calRangeValue = state.lastWeekDate;
                    break;
                case calRangeType.year:
                    state.calRangeValue = state.lastYearDate;
                    break;
            }
        },
        setCalRangeValue(state, action: PayloadAction<string>) {
            state.calRangeValue = action.payload;

            // Update the corresponding last active date for the current view
            if (state.calRangeUsed !== undefined) {
                switch (state.calRangeUsed) {
                    case calRangeType.month:
                        state.lastMonthDate = action.payload;
                        break;
                    case calRangeType.week:
                        state.lastWeekDate = action.payload;
                        break;
                    case calRangeType.year:
                        state.lastYearDate = action.payload;
                        break;
                }
            }
        },
        // Synchronize ALL view dates from a full date (yyyy-MM-dd).
        // Called by FacetNavigation when navigating to the latest entry date.
        // This ensures all views (month/week/year) are aligned to the same time period.
        syncAllViewDates(state, action: PayloadAction<string>) {
            const fullDate = action.payload; // Format: "2025-12-15"

            // Year: extract year portion
            state.lastYearDate = fullDate.substring(0, 4); // "2025"

            // Month: extract year-month portion
            state.lastMonthDate = fullDate.substring(0, 7); // "2025-12"

            // Week: find Monday of the week containing this date
            try {
                const date = parseISO(fullDate);
                const monday = getMonday(date);
                state.lastWeekDate = format(monday, 'yyyy-MM-dd');
            } catch {
                // Fallback: use the date as-is if parsing fails
                state.lastWeekDate = fullDate;
            }
        },
        setPageRangeUsed(state, action: PayloadAction<number>) {
            state.pageRangeUsed=action.payload;
        },
        setUiDimensions(state, action: PayloadAction<uiDimensionsType>){
            state.uiDimensions=action.payload;
        },
        setUrlFacetConstraints(state, action: PayloadAction<Array<string>>){
            state.urlFacetsConstraints=action.payload;
        },
        setUrlConstraintsUsed(state, action: PayloadAction<boolean>){
            state.urlConstraintsUsed=action.payload;
        },
        setModalOpen(state, action: PayloadAction<boolean>){
            state.modalOpen=action.payload;
        },
        setModalDate(state, action: PayloadAction<string>){
            state.modalDate=action.payload;
        },
        setModalMission(state, action: PayloadAction<string>){
            state.modalMission=action.payload;
        },
        setDateIntervalFrom(state, action: PayloadAction<string | null>){
            state.dateIntervalFrom = action.payload;
        },
        setDateIntervalTo(state, action: PayloadAction<string | null>){
            state.dateIntervalTo = action.payload;
        },
        clearDateInterval(state){
            state.dateIntervalFrom = null;
            state.dateIntervalTo = null;
        },
        setPaginationInProgress(state, action: PayloadAction<boolean>){
            state.paginationInProgress = action.payload;
        },
        setIsAutoNavigating(state, action: PayloadAction<boolean>){
            state.isAutoNavigating = action.payload;
        }
    }
});

/**
 * Memoized selector to build date interval filter query string
 * Only recalculates when dateIntervalFrom or dateIntervalTo actually change
 * This prevents excessive re-renders and maintains stable references
 */
export const selectDateIntervalFilterQuery = createSelector(
    (state: any) => state.View.dateIntervalFrom,
    (state: any) => state.View.dateIntervalTo,
    (dateIntervalFrom, dateIntervalTo) => {
        let dateIntervalFq = '';

        if (dateIntervalFrom && dateIntervalTo) {
            dateIntervalFq = `fq=${encodeURIComponent(`file_modified_dt:["${dateIntervalFrom}T00:00:00Z" TO "${dateIntervalTo}T23:59:59Z"]`)}&`;
        } else if (dateIntervalFrom) {
            dateIntervalFq = `fq=${encodeURIComponent(`file_modified_dt:["${dateIntervalFrom}T00:00:00Z" TO *]`)}&`;
        } else if (dateIntervalTo) {
            dateIntervalFq = `fq=${encodeURIComponent(`file_modified_dt:[* TO "${dateIntervalTo}T23:59:59Z"]`)}&`;
        }

        return dateIntervalFq;
    }
);

/**
 * Granular memoized selectors for View slice state.
 * Each selector only recalculates when its specific inputs change,
 * preventing unnecessary re-renders in consuming components.
 */

// Pagination state — used by Query, ResultsListView
export const selectCursors = createSelector(
    (state: any) => state.View.cursorStart,
    (state: any) => state.View.cursorRows,
    (cursorStart: number, cursorRows: number) => ({ cursorStart, cursorRows })
);

// Calendar range — used by DateNav, CalendarView, QrastMain
export const selectCalendarRange = createSelector(
    (state: any) => state.View.calRangeUsed,
    (state: any) => state.View.calRangeValue,
    (calRangeUsed: calRangeType | undefined, calRangeValue: string) => ({ calRangeUsed, calRangeValue })
);

// Date interval filter — used by DateIntervalPicker, Query
export const selectDateInterval = createSelector(
    (state: any) => state.View.dateIntervalFrom,
    (state: any) => state.View.dateIntervalTo,
    (dateIntervalFrom: string | null, dateIntervalTo: string | null) => ({ dateIntervalFrom, dateIntervalTo })
);

// Sort config — used by Query, ResultsListView, SortControl
export const selectSortConfig = createSelector(
    (state: any) => state.View.listSortedFeld,
    (state: any) => state.View.listSortedOrder,
    (listSortedFeld: sortFieldType, listSortedOrder: sortType) => ({ listSortedFeld, listSortedOrder })
);

// View type — used by QrastLayout, QrastMain, CalendarView
export const selectViewType = (state: any): viewType => state.View.viewType;

// Mobile + dimensions — used by QrastLayout
export const selectMobile = createSelector(
    (state: any) => state.View.mobile,
    (state: any) => state.View.uiDimensions,
    (mobile: boolean, uiDimensions: uiDimensionsType) => ({ mobile, uiDimensions })
);

// Auto-navigation flag — used by Query, DateNav
export const selectAutoNav = (state: any): boolean => state.View.isAutoNavigating;

// Color maps — used by Summary, Gradient, CalendarComp
export const selectColorMaps = createSelector(
    (state: any) => state.View.missionColorMap,
    (state: any) => state.View.gradientColorMap,
    (missionColorMap: any, gradientColorMap: any) => ({ missionColorMap, gradientColorMap })
);

// Individual color map selectors — use when you only need one to avoid cross-invalidation
export const selectMissionColorMap = (state: any) => state.View.missionColorMap;
export const selectGradientColorMap = (state: any) => state.View.gradientColorMap;

// Heatmap — used by CalendarComp, MonthViewComp, etc.
export const selectHeatmap = (state: any) => state.View.heatmap;

// Page range — used by Facets, ResultsListView
export const selectPageRange = (state: any): number => state.View.pageRangeUsed;

// Gradient values + loading — used by Summary
export const selectGradient = createSelector(
    (state: any) => state.View.gradientValues,
    (state: any) => state.View.gradientLoading,
    (gradientValues: any, gradientLoading: boolean) => ({ gradientValues, gradientLoading })
);

// Modal state — used by CalendarComp overlay
export const selectModal = createSelector(
    (state: any) => state.View.modalOpen,
    (state: any) => state.View.modalDate,
    (state: any) => state.View.modalMission,
    (modalOpen: boolean, modalDate: string, modalMission: string) => ({ modalOpen, modalDate, modalMission })
);

//
// get the mission colormap
//
export const getMissionColorMap = (): AppThunk => async dispatch => {
    // Background operation - don't block UI with loading spinner
    // dispatch(startLoading());

    //const query = "q=*:*&facet.pivot=mission_ss,colorhexcodemis&facet=true&rows=0&indent=true";
    const query = buildColorQueryString();

    //logger.debug("getMissionColorMap encoded query:" + query);
    //logger.debug("getMissionColorMap decoded query:" + urldecode(query));

    fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_MISSIONS_COLORMAP + "?" + query)
        .then(response => {
            ////logger.debug("response 0: " + Response);
            if(response.ok){
                //logger.debug("getMissionColorMap response 0: ok");
                return response.json();
            }else{
                //logger.debug("getMissionColorMap response 0: not ok");
                throw new Error('Network response was not ok:' + response.status);
            }
        })
        .then(data => {
            if(CONSTANTS.BACKEND_REPLY_IS_ERROR in data){
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_MISSIONS_COLORMAP_ALIAS, data[CONSTANTS.BACKEND_REPLY_IS_ERROR]);
                dispatch(addToQueue(toastProperties));
            }else{
                //logger.debug("## getMissionColorMap data.payload: " + JSON.stringify(data));
                dispatch(setMissionColorMap(data['colorMap']));
            }
            // Background operation - don't affect loading counter
            // dispatch(stopLoading({success: true}));
        })
        .catch((error) => {
            //logger.error("## getMissionColorMap: error="+error);
            // Background operation - don't affect loading counter
            // dispatch(stopLoading({success: false, error: error.message}));
            const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_MISSIONS_COLORMAP_ALIAS, error.message);
            dispatch(addToQueue(toastProperties));
        })
};


//
// get the document type colormap, used by the gradient component
//
export const getGradientColorMap = (): AppThunk => async dispatch => {
    // Background operation - don't block UI with loading spinner
    // dispatch(startLoading());

    const query = "q=*:*&facet.pivot=mission_ss,shorttitle,colorhexcode&facet=true&rows=0";

    //logger.debug("getGradientColorMap encoded query:" + query);
    //logger.debug("getGradientColorMap decoded query:" + urldecode(query));

    fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_GRADIENT_COLORMAP + "?" + query)
        .then(response => {
            ////logger.debug("response 0: " + Response);
            if(response.ok){
                //logger.debug("getGradientColorMap response 0: ok");
                return response.json();
            }else{
                //logger.debug("getGradientColorMap response 0: not ok");
                throw new Error('Network response was not ok:' + response.status);
            }
        })
        .then(data => {
            if ('ERROR' in data){
                //logger.error("getGradientColorMap error: " + data['ERROR']);
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_GRADIENT_COLORMAP_ALIAS, JSON.stringify(data['ERROR']));
                dispatch(addToQueue(toastProperties));
                dispatch(setGradientValues({}));
            }else{
                //logger.debug("## getGradientColorMap data.payload: " + JSON.stringify(data));
                dispatch(setGradientColorMap(data['colorMap']));
            }
            // Background operation - don't affect loading counter
            // dispatch(stopLoading({success: true}));
        })
        .catch((error) => {
            //logger.error("## getGradientColorMap: error="+error);
            // Background operation - don't affect loading counter
            // dispatch(stopLoading({success: false, error: error.message}));
            const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_GRADIENT_COLORMAP_ALIAS, error.message);
            dispatch(addToQueue(toastProperties));
        })
};


//
// Fetch both color maps in parallel and dispatch results in a single batch
// to reduce Summary rerenders from 2 separate dispatches to 1
//
export const getInitialColorMaps = (): AppThunk => async dispatch => {
    const missionQuery = buildColorQueryString();
    const gradientQuery = "q=*:*&facet.pivot=mission_ss,shorttitle,colorhexcode&facet=true&rows=0";

    const [missionResult, gradientResult] = await Promise.all([
        fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_MISSIONS_COLORMAP + "?" + missionQuery)
            .then(response => {
                if (response.ok) return response.json();
                throw new Error('Network response was not ok:' + response.status);
            })
            .catch((error) => {
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_MISSIONS_COLORMAP_ALIAS, error.message);
                dispatch(addToQueue(toastProperties));
                return null;
            }),
        fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_GRADIENT_COLORMAP + "?" + gradientQuery)
            .then(response => {
                if (response.ok) return response.json();
                throw new Error('Network response was not ok:' + response.status);
            })
            .catch((error) => {
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_GRADIENT_COLORMAP_ALIAS, error.message);
                dispatch(addToQueue(toastProperties));
                return null;
            }),
    ]);

    batch(() => {
        if (missionResult) {
            if (CONSTANTS.BACKEND_REPLY_IS_ERROR in missionResult) {
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_MISSIONS_COLORMAP_ALIAS, missionResult[CONSTANTS.BACKEND_REPLY_IS_ERROR]);
                dispatch(addToQueue(toastProperties));
            } else {
                dispatch(setMissionColorMap(missionResult['colorMap']));
            }
        }
        if (gradientResult) {
            if ('ERROR' in gradientResult) {
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_GRADIENT_COLORMAP_ALIAS, JSON.stringify(gradientResult['ERROR']));
                dispatch(addToQueue(toastProperties));
                dispatch(setGradientValues({}));
            } else {
                dispatch(setGradientColorMap(gradientResult['colorMap']));
            }
        }
    });
};

//
// get the gradient values
//
// Track last query to skip redundant fetches (e.g. calendar nav, pagination, sort)
let lastGradientQuery = '';
// Id of the most recent gradient request and whether it is still pending
let gradientRequestId = 0;
let gradientRequestPending = false;

export const getGradientMap = (textSearch: any, facetselected: any, operator: string, dateIntervalFrom?: string, dateIntervalTo?: string): AppThunk => async dispatch => {
    // Background operation - don't block UI with loading spinner
    // dispatch(startLoading());

    //logger.info("getGradientMap facetselected:" + JSON.stringify(facetselected));
    var query = '';

    if(textSearch !== ""){
        query += "q=" + textSearch;
    }

    if(facetselected.length > 0){
        query += '&selectedFacets=';
        for(var val of facetselected){
            query += val.split('@')[1] + ':' + urlencode(val.split('@')[0]) + ';';
            //query += val.split('@')[1] + ':' + val.split('@')[0]; # KEEP to test error handling
        }
    }

    //query += '&op=' + CONSTANTS.OPERATOR_TO_USE;
    query += '&op=' + operator.toUpperCase();

    // date interval filter (yyyy-MM-dd), so the bars count the same documents as the summary
    if(dateIntervalFrom !== undefined){
        query += '&dateFrom=' + urlencode(dateIntervalFrom);
    }
    if(dateIntervalTo !== undefined){
        query += '&dateTo=' + urlencode(dateIntervalTo);
    }

    // Skip if query unchanged (e.g. calendar navigation, pagination, sort)
    if (query === lastGradientQuery) {
        // The loading flag may have been set ahead of time (e.g. a facet added and removed
        // again during auto-navigation); clear it unless the last request is still pending
        if (!gradientRequestPending) dispatch(setGradientLoading(false));
        return;
    }
    lastGradientQuery = query;
    const requestId = ++gradientRequestId;
    gradientRequestPending = true;

    dispatch(setGradientLoading(true));

    //logger.info("getGradientMap encoded query:" + query);
    //logger.info("getGradientMap decoded query:" + urldecode(query));

    fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_GRADIENT_MAP + "?" + query.trim())
        .then(response => {
            if(response.ok){
                //logger.info("getGradientMap response 0: ok");
                return response.json();
            }else{
                //logger.info("getGradientMap response 0: not ok");
                throw new Error('Network response was not ok:' + response.status);
            }
        })
        .then(data => {
            // a newer request was sent meanwhile (e.g. date interval changed): drop this stale reply
            if (requestId !== gradientRequestId) return;
            gradientRequestPending = false;
            batch(() => {
                if ('ERROR' in data){
                    //logger.error("## getGradientMap error: " + data['ERROR']);
                    const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_GRADIENT_MAP_ALIAS+" error", JSON.stringify(data['ERROR']));
                    dispatch(addToQueue(toastProperties));
                    dispatch(setGradientValues({}));
                }else{
                    //logger.debug("## getGradientMap data.payload: " + JSON.stringify(data));
                    dispatch(setGradientValues(data['gradientValues']));
                }
                // Background operation - don't affect loading counter
                // dispatch(stopLoading({success: true}));
                dispatch(setGradientLoading(false));
            });
        })
        .catch((error) => {
            if (requestId !== gradientRequestId) return;
            gradientRequestPending = false;
            lastGradientQuery = '';
            batch(() => {
                //logger.error("## getGradientMap: error="+error);
                // Background operation - don't affect loading counter
                // dispatch(stopLoading({success: false, error: error.message}));
                dispatch(setGradientLoading(false));
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_GRADIENT_MAP_ALIAS+" error", error.message);
                dispatch(addToQueue(toastProperties));
            });
        })
};

//
//get heatmap
//
export const getHeatMap = (start: any, end: any, facetselected: any, textSearch: string, operator: string): AppThunk => async dispatch => {

    dispatch(startLoading());

    //logger.info("getHeatMap facetselected:" + JSON.stringify(facetselected));
    var query = ''; 
    query = 'start=' + start + '&end=' + end;
    if(facetselected.length > 0){
        query += '&facets='
        
        for(var i=0; i<facetselected.length; i++){
            if(i === 0)
                query += facetselected[i].split('@')[1] + ':' + urlencode(facetselected[i].split('@')[0]);
            else
                query += ',' + facetselected[i].split('@')[1] + ':' + urlencode(facetselected[i].split('@')[0]);
            //query += val.split('@')[1] + ':' + val.split('@')[0]; # KEEP to test error handling
        }
    }
    if(textSearch !== ""){
        query += '&text=' + textSearch;
    }
    //query += '&op=' + CONSTANTS.OPERATOR_TO_USE;
    query += '&op=' + operator.toUpperCase();

    //logger.info("getHeatMap encoded query:" + query);
    //logger.info("getHeatMap decoded query:" + urldecode(query));

    fetchWithTimeout(CONSTANTS.ENDPOINT.REST_API + CONSTANTS.REST_GET_HEATMAP + "?" + query.trim())
        .then(response => {
            if(response.ok){
                //logger.info("getHeatMap response 0: ok");
                return response.json();
            }else{
                //logger.info("getHeatMap response 0: not ok");
                throw new Error('Network response was not ok:' + response.status);
            }
        })
        .then(data => {
            batch(() => {
                if ('ERROR' in data){
                    //logger.error("## getHeatMap error: " + data['ERROR']);
                    const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_HEATMAP_ALIAS+" error", JSON.stringify(data['ERROR']));
                    dispatch(addToQueue(toastProperties));
                    dispatch(setHeatMap({}));
                }else{
                    //logger.debug("## getHeatMap data.payload: " + JSON.stringify(data));
                    dispatch(setHeatMap(data));
                }
                dispatch(stopLoading({success: true}));
            });
        })
        .catch((error) => {
            batch(() => {
                //logger.error("## getHeatMap: error="+error);
                dispatch(stopLoading({success: false, error: error.message}));
                const toastProperties: toastListProp = createToastProperties(toastType.error, CONSTANTS.REST_GET_GRADIENT_MAP_ALIAS+" error", error.message);
                dispatch(addToQueue(toastProperties));
            });
        })
};

//
// Switch to Calendar View
// Simplified: Just switches view type, calendar navigation is independent
//
export const switchToCalendarView = (): AppThunk => async (dispatch) => {
    // Switch to calendar view
    dispatch(setType(viewType.Calendar));
};

export const {setTotal, setType, setCursors, setSortField, setSortOrder, setCalRangeUsed, setCalRangeValue, syncAllViewDates, setMobile, setShowDebugInfo, setMissionColorMap, setGradientColorMap, setGradientValues, setGradientLoading, setHeatMap, setPageRangeUsed, setUiDimensions, setUrlFacetConstraints, setUrlConstraintsUsed, setModalOpen, setModalDate, setModalMission, setDateIntervalFrom, setDateIntervalTo, clearDateInterval, setPaginationInProgress, setIsAutoNavigating} = viewSlice.actions;

export default viewSlice.reducer